export default __webpack_public_path__ + "static/m-04-8f07b23f29105f59d9cd41d40bdb9bcf.jpeg";